import { Progress as ProgressPrimitive } from '@base-ui/react/progress';

import { cn } from '@/lib/utils';

export type ProgressTrackProps = ProgressPrimitive.Track.Props;

const ProgressTrack = ({ className, ...props }: ProgressTrackProps) => {
  return (
    <ProgressPrimitive.Track
      className={cn(
        'relative flex h-1.5 w-full items-center overflow-visible bg-gray-200',
        className,
      )}
      data-slot="progress-track"
      {...props}
    />
  );
};

export default ProgressTrack;
